export interface BreadcrumbItem {
    label: string;
    url?: string;
}

export function serializeBreadcrumbItems(items: BreadcrumbItem[]): string {
    return JSON.stringify(items.map(({ label, url }) => ({ label, url: url ?? '' })));
}
